import { Component, Vue, Prop } from 'vue-property-decorator';
import { QuestionnaireDTO } from '@/models/QuestionnaireDTO';
import InsuranceAutoComplete from '@/components/inputs/InsuranceAutoComplete/InsuranceAutoComplete.vue';
import InputText from '@/components/inputs/InputText/InputText.vue';
import InputCheckbox from '@/components/inputs/InputCheckbox/InputCheckbox.vue';
import InputMaskedText from '@/components/inputs/InputMaskedText/InputMaskedText.vue';
import StepStatus from '@/components/StepStatus/StepStatus.vue';
import LogoutButton from '@/components/LogoutButton/LogoutButton.vue';

@Component({
  components: {
    InsuranceAutoComplete,
    InputText,
    InputCheckbox,
    InputMaskedText,
    StepStatus,
    LogoutButton,
  },
})
export default class QuestInsurance extends Vue {
  @Prop({ required: false, default: false }) public isRecap!: boolean;
  public partId: number | undefined;
  public questionnaire: QuestionnaireDTO = {} as QuestionnaireDTO;
  public updating?: boolean = false;
  public errorMessage: string = '';
  public error: boolean = false;
  public avsError: boolean = false;

  /**
   * Get an array of all the property names from the questionnaire data in lowercase
   */
  get instanceFields(): string[] {
    if (this.$store.state.questionnaire.insurance) {
      let fields: string[] = [];
      Object.keys(this.questionnaire.insurance).forEach(e => fields.push(e.toLowerCase()));
      return fields;
    }
    return [];
  }
  
  /**
   * Get the errors returned by the API corresponding to the questionnaire data properties
   */
  get errors(): string[] {
    if (this.$store.state.questionnaireValidationErrors) {
      const obj = this.$store.state.questionnaireValidationErrors;
      let errorFields: string[] = [];
      Object.keys(obj).forEach((e) => {
        if (this.instanceFields.includes(e.toLowerCase())) {
          errorFields.push(obj[e].errors);
        }
      });
      return errorFields;
    }

    return [];
  }

  protected mounted() {
    this.partId = Number(this.$route.params.partId);
    // this.fetchQuestionnaire(this.partId);
    this.questionnaire = this.$store.state.questionnaire;
  }


  protected async onSubmit(event: any) {
    this.$store.commit('setQuestionnaireInsurance', this.questionnaire.insurance);
    if (event.submitter.id === 'btn-continue') {
      this.$router.push({
        name: 'atHomeDoctor',
        params: {
          screening: this.$route.params.screening,
          partId: String(this.partId),
        },
      });
    } else {
      this.$router.push({
        name: 'atHomeAddress',
        params: {
          screening: this.$route.params.screening,
          partId: String(this.partId),
        },
      });
    }
  }
}

